import { auth } from '../../../firebase';

/**
 * Action Creators
 */
export const logoutStart = () => ({
    type: 'LOGOUT_START'
});

export const logoutSuccess = () => ({
    type: 'LOGOUT_SUCCESS'
});

export const logoutFailure = (error) => ({
    type: 'LOGOUT_FAILURE',
    payload: error
});

/**
 * logoutUser - התנתקות משתמש (סטנד-אלון)
 * מנקה את ה-state ומתנתק מ-Firebase
 */
export const logoutUser = () => async (dispatch) => {
    try {
        dispatch(logoutStart());
        console.log('👋 Logging out user...');

        // התנתקות מ-Firebase
        await auth.signOut();

        // ניקוי localStorage
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('dashboard_')) {
                localStorage.removeItem(key);
            }
        });

        dispatch(logoutSuccess());
        dispatch({ type: 'CLEAR_LICENSE' });
        console.log('✅ User logged out successfully');
        return { success: true };
    } catch (error) {
        console.error('❌ Error logging out:', error);
        dispatch(logoutFailure(error.message));
        throw error;
    }
};
